import { SEO } from "../components/SEO";
import { PageHeader } from "../components/PageHeader";
import { site } from "../lib/site";
import { breadcrumbJsonLd } from "../lib/structured-data";

export function MentionsLegales() {
  return (
    <>
      <SEO
        title={`Mentions légales - ${site.name}`}
        description="Mentions légales du site Anexya : éditeur, hébergeur, propriété intellectuelle et responsabilités."
        path="/mentions-legales"
        jsonLd={breadcrumbJsonLd([
          { name: "Accueil", url: `${site.baseUrl}/` },
          { name: "Mentions légales", url: `${site.baseUrl}/mentions-legales` },
        ])}
      />
      <PageHeader
        eyebrow="Informations légales"
        title="Mentions légales"
        breadcrumbs={[{ label: "Accueil", to: "/" }, { label: "Mentions légales" }]}
      />

      <section className="section bg-white">
        <div className="container-page max-w-3xl prose-legal">
          <h2>Éditeur du site</h2>
          <p>
            <strong>{site.founder}</strong>, Entrepreneur Individuel exerçant sous le nom
            commercial «&nbsp;{site.name}&nbsp;»
            <br />
            {site.address.street}, {site.address.postalCode} {site.address.city}
            <br />
            Téléphone&nbsp;:{" "}
            <a href={site.phoneHref}>{site.phoneDisplay}</a> · Email&nbsp;:{" "}
            <a href={site.emailHref}>{site.email}</a>
            <br />
            SIRET&nbsp;: {site.siret}
            <br />
            Directeur de la publication&nbsp;: {site.founder}
          </p>

          <h2>Hébergement</h2>
          <p>
            Le site est hébergé par un prestataire professionnel situé en Union européenne.
            Les coordonnées de l'hébergeur peuvent être obtenues sur simple demande à{" "}
            <a href={site.emailHref}>{site.email}</a>.
          </p>

          <h2>Propriété intellectuelle</h2>
          <p>
            L'ensemble des contenus (textes, images, logo, illustrations, code source) présents
            sur ce site est la propriété exclusive de {site.legalName}, sauf mention contraire.
            Toute reproduction, représentation ou diffusion, totale ou partielle, sans
            autorisation écrite préalable, est interdite et constituerait une contrefaçon au
            sens des articles L.335-2 et suivants du Code de la propriété intellectuelle.
          </p>

          <h2>Responsabilité</h2>
          <p>
            Les informations présentées sur ce site sont fournies à titre indicatif. {site.name}{" "}
            met tout en œuvre pour en garantir l'exactitude et l'actualité, sans pouvoir l'assurer
            de manière absolue. L'utilisateur reconnaît utiliser ces informations sous sa
            responsabilité exclusive.
          </p>

          <h2>Liens externes</h2>
          <p>
            Ce site peut contenir des liens vers d'autres sites. {site.name} n'exerce aucun
            contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
          </p>

          <h2>Données personnelles</h2>
          <p>
            Le traitement de vos données personnelles est détaillé dans notre{" "}
            <a href="/politique-de-confidentialite">politique de confidentialité</a>.
          </p>

          <h2>Droit applicable</h2>
          <p>
            Le présent site est soumis au droit français. Tout litige relatif à son utilisation
            relève des juridictions françaises compétentes.
          </p>
        </div>
      </section>
    </>
  );
}
